import type { FunctionComponent } from 'react';

import { TableSkeleton } from '~/ui/core/table/Table';

import { useArchivedItemsColumnWidths } from './ArchivedItemRow';

const SKELETON_ROW_COUNT = 4;

export const ArchivedItemsTableSkeleton: FunctionComponent = () => {
    const columnWidths = useArchivedItemsColumnWidths();

    return (
        <TableSkeleton
            aria-label="Loading archived items"
            columnWidths={columnWidths}
            data-testid="archived-items-table-skeleton"
            rowCount={SKELETON_ROW_COUNT}
        />
    );
};
